import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CanActivateGuard } from 'src/core/guards/can-active.guard';
import { ForwardGuard } from 'src/core/guards/forward.guard';
import { LoginComponent } from './login/login.component';
import { LoginFailedComponent } from './login-failed/login-failed.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [CanActivateGuard]
  },
  {
    path: 'auth',
    component: AuthCallbackComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ForwardGuard]
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
    canActivate: [ForwardGuard]
  }
];
